import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAllBookmarks } from '../../../actions';
import { flattenToAppURL } from '@plone/volto/helpers';

const defaultBookmarks = [];

const Bookmarks = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userSession.token);
  const bookmarks = useSelector(
    (state) => state.collectivebookmarks?.items || defaultBookmarks,
  );
  const filteredBookmarks = bookmarks.filter((bookmark) => {
    return bookmark['@type'] === 'Wiki';
  });
  const bookmarkdelete = useSelector(
    (state) => state.collectivebookmarks?.delete || {},
  );

  useEffect(() => {
    if (token) {
      dispatch(getAllBookmarks(''));
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (token && bookmarkdelete === 'loaded') {
      dispatch(getAllBookmarks(''));
    }
  }, [dispatch, token, bookmarkdelete]);

  return (
    <div className="navbar-department-list">
      {filteredBookmarks
        ? filteredBookmarks.map((bookmark, idx) => {
            return (
              <Link
                className="department"
                key={idx}
                to={flattenToAppURL(bookmark['@id'])}
              >
                <div className="text">{bookmark.title}</div>
              </Link>
            );
          })
        : null}
    </div>
  );
};

export default Bookmarks;
